/** @fileoverview Vertical list of student task cards. */

import { Stack } from '@mantine/core'
import type { StudentTask } from '../types'
import { StudentTaskCard } from './StudentTaskCard'

interface StudentTasksListProps {
  tasks: readonly StudentTask[]
  onOpen: (task: StudentTask) => void
}

export function StudentTasksList({ tasks, onOpen }: StudentTasksListProps) {
  return (
    <Stack spacing="md">
      {tasks.map(task => (
        <StudentTaskCard key={task.id} task={task} onOpen={onOpen} />
      ))}
    </Stack>
  )
}
